import { formatValue } from '../utils/data-format';

interface ApiErrorComponentProps {
  value: string;
  format?: string;
  patternChar?: string;
}

export const FormattedValue = ({ value, format, patternChar = '#' }: ApiErrorComponentProps) => {
  if (format) {
    return <>{formatValue(value, format, patternChar).formattedValue}</>;
  } else {
    return <>{value}</>;
  }
};
